import type { Result } from '@empathyco/x-types'
import type Vue from 'vue'
import { getCurrentInstance } from 'vue'

interface UseGetProductDetails {
  getResult: () => Result | undefined
}

export function useGetProductDetails({ productId }: { productId: string }): UseGetProductDetails {
  const {
    proxy: { $x },
  } = getCurrentInstance() as { proxy: Vue }

  function getResult(): Result | undefined {
    const result = $x.results.find(result => result.id === productId)
    return result
  }

  return {
    getResult,
  }
}
